(function () {
  'use strict';

  function initialiseClosureNotice() {
    var dialog = document.getElementById('cl-closure-notice');
    if (!dialog || dialog.hasAttribute('data-cl-closure-initialised')) return;
    dialog.setAttribute('data-cl-closure-initialised', 'true');

    var reopenButtons = Array.from(document.querySelectorAll('[data-reopen="cl-closure-notice"]'));
    var closeButtons = Array.from(dialog.querySelectorAll('[data-close]'));
    var expiresAt = Date.parse(dialog.getAttribute('data-expires-at') || '');
    var storageKey = 'cl-closure-2026-11';
    var maximumDelay = 2147483647;
    var timer = null;
    var ended = false;
    var previousFocus = null;
    var seenOnThisPage = false;
    var autoOpenPending = false;
    var blockerObserver = null;

    function stopDeferredAutoOpen() {
      autoOpenPending = false;
      if (blockerObserver) blockerObserver.disconnect();
      blockerObserver = null;
      document.removeEventListener('close', resumeDeferredAutoOpen, true);
      document.removeEventListener('transitionend', resumeDeferredAutoOpen, true);
      document.removeEventListener('animationend', resumeDeferredAutoOpen, true);
    }

    function remember(value) {
      stopDeferredAutoOpen();
      seenOnThisPage = true;
      try { window.sessionStorage.setItem(storageKey, value); } catch (error) {}
    }

    function alreadySeen() {
      if (seenOnThisPage) return true;
      try { return window.sessionStorage.getItem(storageKey) !== null; } catch (error) { return false; }
    }

    function restoreFocus() {
      var target = previousFocus;
      previousFocus = null;
      if (target && target.isConnected && !dialog.contains(target) && typeof target.focus === 'function') {
        try { target.focus({ preventScroll: true }); } catch (error) {}
      }
    }

    function closeDialog() {
      if (dialog.open) {
        try { dialog.close(); } catch (error) { dialog.removeAttribute('open'); }
      }
      restoreFocus();
    }

    function retire() {
      if (ended) return;
      ended = true;
      stopDeferredAutoOpen();
      if (timer !== null) window.clearTimeout(timer);
      timer = null;
      document.removeEventListener('visibilitychange', synchronise);
      window.removeEventListener('pageshow', synchronise);
      reopenButtons.forEach(function (button) {
        button.removeEventListener('click', reopen);
        button.remove();
      });
      closeDialog();
      dialog.hidden = true;
      dialog.remove();
    }

    function active() {
      if (ended) return false;
      var now = Date.now();
      if (!Number.isFinite(expiresAt) || !Number.isFinite(now) || now >= expiresAt) {
        retire();
        return false;
      }
      return true;
    }

    function synchronise() {
      if (!active()) return;
      if (timer !== null) window.clearTimeout(timer);
      timer = window.setTimeout(synchronise, Math.min(maximumDelay, Math.max(1, expiresAt - Date.now())));
    }

    function resumeDeferredAutoOpen() {
      if (!autoOpenPending) return;
      if (ended || alreadySeen()) {
        stopDeferredAutoOpen();
        return;
      }
      openDialog(true);
    }

    function deferAutoOpen() {
      if (autoOpenPending || ended || alreadySeen()) return;
      autoOpenPending = true;
      document.addEventListener('close', resumeDeferredAutoOpen, true);
      document.addEventListener('transitionend', resumeDeferredAutoOpen, true);
      document.addEventListener('animationend', resumeDeferredAutoOpen, true);
      var observationRoot = document.documentElement || document.body;
      if (observationRoot && typeof window.MutationObserver === 'function') {
        try {
          blockerObserver = new window.MutationObserver(resumeDeferredAutoOpen);
          blockerObserver.observe(observationRoot, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['open', 'hidden', 'aria-hidden', 'aria-modal', 'style', 'class']
          });
        } catch (error) {
          if (blockerObserver) blockerObserver.disconnect();
          blockerObserver = null;
        }
      }
    }

    function isActuallyVisible(element) {
      if (!element || !element.isConnected || typeof element.getClientRects !== 'function') return false;
      var ancestor = element;
      while (ancestor && ancestor.nodeType === 1) {
        if (ancestor.hidden || ancestor.getAttribute('aria-hidden') === 'true' ||
            (ancestor.tagName === 'DETAILS' && !ancestor.open)) return false;
        var style = window.getComputedStyle(ancestor);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' ||
            parseFloat(style.opacity) === 0 || style.contentVisibility === 'hidden') return false;
        ancestor = ancestor.parentElement;
      }
      var width = window.innerWidth || document.documentElement.clientWidth;
      var height = window.innerHeight || document.documentElement.clientHeight;
      return Array.from(element.getClientRects()).some(function (rect) {
        return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 &&
          rect.left < width && rect.top < height;
      });
    }

    function openDialog(automatically) {
      if (!active() || dialog.open) return;
      var anotherModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(function (element) {
        return element !== dialog && isActuallyVisible(element);
      });
      if (anotherModal) {
        if (automatically) deferAutoOpen();
        return;
      }
      stopDeferredAutoOpen();
      previousFocus = document.activeElement;
      dialog.hidden = false;
      try {
        dialog.showModal();
        remember('seen');
      } catch (error) {
        retire();
      }
    }

    function dismiss(event) {
      if (event) event.preventDefault();
      if (!active()) return;
      remember('dismissed');
      closeDialog();
    }

    function reopen(event) {
      event.preventDefault();
      openDialog();
    }

    if (!active()) return;
    if (typeof dialog.showModal !== 'function' || typeof dialog.close !== 'function') {
      retire();
      return;
    }

    closeButtons.forEach(function (button) { button.addEventListener('click', dismiss); });
    reopenButtons.forEach(function (button) {
      button.addEventListener('click', reopen);
      button.hidden = false;
    });
    dialog.addEventListener('cancel', dismiss);
    dialog.addEventListener('close', function () {
      if (!ended) remember('dismissed');
      restoreFocus();
    });
    document.addEventListener('visibilitychange', synchronise);
    window.addEventListener('pageshow', synchronise);
    synchronise();
    if (!alreadySeen()) openDialog(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseClosureNotice, { once: true });
  } else {
    initialiseClosureNotice();
  }
})();
